import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface UIConfigStore {
  miniCartEnabled: boolean;
  stickyHeaderEnabled: boolean;
  selectedState: string;
  setMiniCartEnabled: (enabled: boolean) => void;
  setStickyHeaderEnabled: (enabled: boolean) => void;
  setSelectedState: (state: string) => void;
}

export const useUIConfigStore = create<UIConfigStore>()(
  devtools(
    set => ({
      miniCartEnabled: false,
      stickyHeaderEnabled: false,
      selectedState: 'CT',
      setMiniCartEnabled: enabled => set({ miniCartEnabled: enabled }, undefined, 'setMiniCartEnabled'),
      setStickyHeaderEnabled: enabled => set({ stickyHeaderEnabled: enabled }, undefined, 'setStickyHeaderEnabled'),
      setSelectedState: state => set({ selectedState: state }, undefined, 'setSelectedState'),
    }),
    { name: 'UIConfigStore' },
  ),
);
